import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IMerchProductOrderResponse from '../../../models/responces/IMerchProductOrderResponse';
import IMerchProductOrderItem from '../../../models/restful/IMerchProductOrderItem';

export interface IApiDeleteOrderParams {
  id?: number;
  orderItem?: IMerchProductOrderItem;
}
const apiDeleteOrderItem = (params: IApiDeleteOrderParams) =>
  sendAxiosRequest({
    method: 'delete',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'order',
      action: 'deleteOrderItem'
    }),
    data: params.orderItem || { ID: params.id },
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IMerchProductOrderResponse>;
export default apiDeleteOrderItem;
